"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var I18n = require("i18n-js");
var url_helpers_1 = require("../shared/url_helpers");
var lodash_1 = require("lodash");
var sanitized_render_1 = require("@reverbdotcom/commons/dist/components/sanitized_render");
var rql_1 = require("../../schemas/rql");
var negotiation_getters_1 = require("./negotiation_getters");
function lastOfferInitiator(listing, negotiation, party) {
    if (party === rql_1.core_apimessages_NegotiationParty.BUYER) {
        return {
            name: listing.shop.name,
            linkOpen: "<a href=\"" + url_helpers_1.default.shopPath(listing.shop.slug) + "\">",
            linkClose: '</a>',
        };
    }
    var buyerShop = negotiation.buyer.shop;
    if (buyerShop) {
        return { name: buyerShop.name, linkOpen: "<a href=\"" + url_helpers_1.default.shopPath(buyerShop.slug) + "\">", linkClose: '</a>' };
    }
    return { name: negotiation.buyer.name, linkOpen: '', linkClose: '' };
}
function summaryTotalOrAddress(prices, negotiation, party) {
    if (party === rql_1.core_apimessages_NegotiationParty.BUYER) {
        var lastOfferTotal = lodash_1.get(prices, 'totalPrice.display');
        return (React.createElement("p", { className: "offers-form__negotiation-summary__details" }, I18n.t('discovery.offers.offerTotal', { offerTotal: lastOfferTotal })));
    }
    var address = lodash_1.get(negotiation, 'shippingLocation.displayLocation');
    if (party === rql_1.core_apimessages_NegotiationParty.SELLER && !!address) {
        return (React.createElement("p", { className: "offers-form__negotiation-summary__details" }, I18n.t('discovery.offers.shipToAddress', { address: address })));
    }
    return null;
}
function sellerAlerts(negotiation) {
    var location = lodash_1.get(negotiation, 'shippingLocation.displayLocation');
    var buyerName = negotiation.buyer.name;
    if (!location) {
        return (React.createElement("div", { className: "alert-box alert-box--blue mt-2" }, I18n.t('discovery.offers.alert.unknownLocation', { buyerName: buyerName })));
    }
    if (negotiation.buyerOutsideListingShippingRegions) {
        return (React.createElement("div", { className: "alert-box mt-2" }, I18n.t('discovery.offers.alert.buyerOutsideShippingLocations', { location: location, buyerName: buyerName })));
    }
    return null;
}
function renderQuantityDescription(negotiation) {
    var quantity = negotiation_getters_1.offerQuantity(negotiation_getters_1.lastOffer(negotiation));
    if (quantity > 1) {
        return (React.createElement("p", { className: "offers-form__negotiation-summary__quantity" }, I18n.t('discovery.offers.summaryWithQuantity', { quantity: quantity })));
    }
    return null;
}
function renderConvertedFrom(prices, originalPrices) {
    if (originalPrices && prices.price.currency !== originalPrices.price.currency) {
        var price = lodash_1.get(originalPrices, 'price.display');
        var priceText = price + " <span class=\"size-80 weight-normal\">" + lodash_1.get(originalPrices, 'price.currency') + "</span>";
        var text = I18n.t('discovery.offers.convertedFrom', {
            price: priceText,
            shipping: lodash_1.get(originalPrices, 'shippingPrice.display'),
        });
        return (React.createElement("p", { className: "offers-form__negotiation-summary__sub-price" },
            React.createElement(sanitized_render_1.default, { html: text })));
    }
}
function NegotiationSummary(_a) {
    var prices = _a.prices, originalPrices = _a.originalPrices, listing = _a.listing, negotiation = _a.negotiation, party = _a.party;
    var shippingPrice = lodash_1.get(prices, 'shippingPrice.display', '');
    var offerAmount = lodash_1.get(prices, 'price.display', '');
    var _b = lastOfferInitiator(listing, negotiation, party), linkOpen = _b.linkOpen, linkClose = _b.linkClose, name = _b.name;
    return (React.createElement("div", { className: "offers-form__negotiation-summary" },
        React.createElement("p", { className: "offers-form__negotiation-summary__title" },
            React.createElement(sanitized_render_1.default, { html: I18n.t('discovery.offers.offerFromPartyName', { linkOpen: linkOpen, linkClose: linkClose, partyName: name }) })),
        React.createElement("div", { className: "offers-form__negotiation-summary__price-block" },
            React.createElement("p", { className: "offers-form__negotiation-summary__price" },
                I18n.t('discovery.offers.negotiationSum', { offerAmount: offerAmount, shippingPrice: shippingPrice }),
                negotiation.taxIncluded &&
                    React.createElement("span", { className: "offers-form__negotiation-summary__tax-hint" },
                        "(",
                        negotiation.taxIncludedHint,
                        ")")),
            renderConvertedFrom(prices, originalPrices)),
        renderQuantityDescription(negotiation),
        summaryTotalOrAddress(prices, negotiation, party),
        party === rql_1.core_apimessages_NegotiationParty.SELLER &&
            sellerAlerts(negotiation)));
}
exports.default = NegotiationSummary;
//# sourceMappingURL=negotiation_summary.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/offers/negotiation_summary.js
// module id = Pzth
// module chunks = 20 21